export const ICON_CONFIG_CHANGED_ICON = "iconConfigHaveChangedTheIcon";
